import { getParentUrl } from '@/helpers'

export const company = ({ company, options }) => company || options.subdomain

export const embedId = ({ embedId }) => embedId

export const options = ({ options }) => options

export const isWozTestAgent = ({ options }) => {
  const url = options.url

  if (!url) return false

  const wozAgentPaths = ['/woz/agents/edit/', '/woz/agents/new']

  return wozAgentPaths.some(path => url.includes(path))
}

export const isPopup = ({ options }) => options.popup === 'true'

export const forceSelectFields = ({ options }) =>
  options.forceSelectFields === 'true'

export const customFields = ({ customFields }) => customFields

export const organization = ({ organization }) => organization

export const active = ({ active }) => active

export const hiding = ({ hiding }) => hiding

export const settings = ({ settings }) => settings

export const filterAgents = ({ filterAgents }) => filterAgents

export const parentUrl = ({ parentUrl, options }) =>
  getParentUrl(parentUrl, options)

export const form = ({ form }) => form

export const ready = ({ ready }) => ready

export const onFocus = ({ onFocus }) => onFocus

export const fetchingForm = ({ fetchingForm }) => fetchingForm

export const subDomainStatus = ({ subDomainStatus }) => subDomainStatus

export const whitelabel = ({ whitelabel }) => whitelabel

export const culture = ({ options, culture }) =>
  culture || options.culture || options.language

export const showFooterPoweredBy = ({ options }) =>
  Object.hasOwn(options, 'showFooterPoweredBy')
    ? options.showFooterPoweredBy === 'true'
    : true
